export default "__VITE_ASSET__1428a0da__"